/* eslint-disable default-case */
import React, { useState, useEffect } from "react";
import {
  useLocation,
  useNavigate,
  useOutletContext,
} from "react-router-dom";
import { Grid } from "@material-ui/core";
import { useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import CustomeTextField from "components/UpdateUi/CustomeTextField";
import ToastModal from "views/components/ToastModal";
import CustomSelectNew from "../../../components/UpdateUi/CustomeSelect";
import { toCamelCase } from "utils/Utils";
import { glHeadLists } from "assets/properties/properties";
import { coledingGlList } from "assets/properties/properties";
import { parseAndSetFlag } from "utils/Utils";
import { removeUnderscores } from "utils/Utils";

const GlHeadCreate = ({ classes }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { productTypeList, findData, selectedProductType } = location.state || {};
  const { authToken } = useSelector((state) => state.login.authData);
  const [productType, setProductType] = useState(selectedProductType);
  const [callInProgress, setCallInProgress] = useState(false);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");
  const [redirectURL, setRedirectURL] = useState("");
  const [isEditMode, setIsEditMode] = useState(false);
  const outletData = useOutletContext();
  console.log(outletData?.enablePartnerColendingInScheme,"fsdjfsbkjdfbk")
  const partnerColendingEnabled = parseAndSetFlag(
    outletData?.enablePartnerColendingInScheme
  );
  
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
    if (redirectURL !== "") {
      setRedirectURL("");
      navigate(redirectURL);
    }
  };

  const removeList = outletData?.removeGlHeads !== undefined && JSON.parse(outletData?.removeGlHeads);
  const [glHeadAllList, setGlHeadAllList] = useState([]);
  const [glHeadFields, setGlHeadFields] = useState([]);

  useEffect(() => {
    GetData();
  }, []);

  const GetData = async () => {
    setCallInProgress(true);

    const result = await apiHandler({
      url: endpoint.GL_HEAD_LIST_API,
      authToken,
    });

    setCallInProgress(false);
    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
      const finalRemoveList = result?.data?.filter(
      (item) => !removeList.includes(item)
    );
    const filteredList = finalRemoveList.filter(
      (item) =>
        partnerColendingEnabled || !coledingGlList.includes(item)
    );
    setGlHeadAllList(filteredList);
    }
  };

  useEffect(() => {
    if (glHeadAllList.length > 0 && !findData) {
      setGlHeadFields(
        glHeadAllList.map(name => ({
          name,
          code: "",
          description: "",
          codeError: false,
          descriptionError: false,
          disabled: false,
        }))
      );
    }
  }, [glHeadAllList, findData]);

useEffect(() => {
  if (
    findData &&
    findData.glHeads &&
    Array.isArray(findData.glHeads) &&
    glHeadAllList.length > 0
  ) {
    setIsEditMode(true);

    const filledFields = glHeadAllList.map((name) => {
      const matched = findData.glHeads.find((item) => item.name === name);
      if (matched) {
        return {
          name: matched.name,
          code: matched.code,
          description: matched.description,
          codeError: false,
          descriptionError: false,
          disabled: Boolean(matched?.code),
        };
      } else {
        return {
          name,
          code: "",
          description: "",
          codeError: false,
          descriptionError: false,
          disabled: false
        };
      }
    });

    setGlHeadFields(filledFields);
  }
}, [findData, glHeadAllList]);

  const handleFieldChange = (index, key, value) => {
    const updatedFields = [...glHeadFields];
    updatedFields[index][key] = value;
    if (key === "code" || key === "description") {
      updatedFields[index][`${key}Error`] = false;
    }
    setGlHeadFields(updatedFields);
  };

  const isValidated = () => {
    const updatedFields = glHeadFields.map((item) => ({
      ...item,
      codeError: item.code.trim() === "",
      descriptionError: item.description.trim() === "",
    }));

    setGlHeadFields(updatedFields);
    return updatedFields.every(
      (item) => !item.codeError && !item.descriptionError
    );
  };

  const saveStructureInformation = async () => {
    setCallInProgress(true);

    const glHeadsPayload = glHeadFields.map((field) => ({
      code: field?.code.toUpperCase(),
      name: field?.name,
      description: field?.description,
    }));

    const res = await apiHandler({
      url: endpoint.GL_HEAD_CREATE_BULK,
      method: "POST",
      authToken: authToken,
      data: {
        productType: productType,
        glHeads: glHeadsPayload,
      },
    });

    setCallInProgress(false);

    if (res?.data?.error_code) {
      toastUpdate(
        "Error",
        res?.data?.user_description || "Error creating GL heads",
        true
      );
      return "ERROR";
    }

    return "SUCCESS";
  };

  const handleStructureSubmit = async () => {
    // if (isValidated()) {
      toastUpdate("", "", false);
      const status = await saveStructureInformation();
      if (status === "SUCCESS") {
        toastUpdate("Success", "GL-Head Type(s) created successfully!", true);
        setRedirectURL("/coreservice/GLHead");
      }
    // }
  };

  const handleCancel = () => {
    navigate("/coreservice/GLHead");
  };

  return (
    <div>
      <Grid container>
        <Grid item xs={12}>
          <SubHeader
            label="Create GL-Head Office"
            button1="Save"
            button2="Cancel"
            button1click={handleStructureSubmit}
            button2click={handleCancel}
          />
        </Grid>
      </Grid>
      <Grid container className={classes.inputFieldContainer}>
        <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
          <CustomSelectNew
            label="Product Type*"
            id="product_type"
            value={productType}
            setState={setProductType}
            data={productTypeList}
            type="newSchemeCharge"
            disabled
          />
        </Grid>
      </Grid>
      <Grid item spacing={2} className={classes.inputContainer}>
        {glHeadFields.map((field, index) => (
          <Grid
            container
            spacing={2}
            key={field?.name}
            className={classes.inputFieldContainer}
          >
           <Grid item xs={12} sm={4} md={4} className={classes.fieldContaienr}>
      <CustomeTextField
        label="Name"
        value={removeUnderscores(field?.name)}
        disabled
      />
    </Grid>
    <Grid item xs={12} sm={4} md={4} className={classes.fieldContaienr}>
      <CustomeTextField
        label="Code"
        required
        value={field?.code}
        error={field?.codeError}
        setState={(val) => handleFieldChange(index, "code", val)}
        disabled={field?.disabled}
        type="noCapital"
      />
    </Grid>
    <Grid item xs={12} sm={4} md={4} className={classes.fieldContaienr}>
      <CustomeTextField
        label="Description"
        required
        value={field?.description}
        error={field?.descriptionError}
        setState={(val) => handleFieldChange(index, "description", val)}
      />
    </Grid> 
          </Grid>
        ))}
      </Grid>

      {toast && (
        <ToastModal
          toastMessage={toastMessage}
          toastMessageType={toastMessageType}
          toastUpdate={toastUpdate}
        />
      )}
      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
    </div>
  );
};

export default GlHeadCreate;
